var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterDropdown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_124_2355",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_124_2355",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB60lEQVR4nO3cy0rDQBSA4ak+gzeQ9jRTXYidWCbWJ+krKCq40LdwoSPe6NtKqt3UW9OKPTPzfzC7MITzNwkUEmMAAAAAAAAAAAAAAAAAAIBpMYMljEbrxpg1s6xef7hbOH9VOP9knX+2ZXXZOTjeXnrjTLS936nnZ8vq1fb9i3X+plOWsnAMW/oH6/x4Zt3vu2H3z88+Mftu2K1nNTu/wlWPMhh0Gm84Kfs5xnQFovwaI/wwv2vTUOvjNvXdhkRZPMa4vn01fqbMEYQoi8R4X8+mqcL58zk2JkrzGONev7owTfWOjja+eigRZbkY9Uzr2ZpFFAe+bV11N2+UvX5VmMzIYND51x8uURTFmCKKohhTRFEUY4ooRk8Mohh9MXKOIlpj5BhFtMfIKYrEEiOHKBJbjJSjSKwxUowiscdIKYqkEiOFKJJajJijSKoxYowiqceIKYrkEiOGKJJbDM1RJNcYGqNI7jE0RRFi6IkixNATRYihJ4oQQ08UIYaeKEIMPVGEGHqiCDH0RBFi6IkixNATRYih6p2L0OTYZP+bUnaljIkRV5TAlaEnSiCGniiBGHqiBGLoiRKIoSdKIIaSj7tYPo6zOt3Dk62i9GfW+dvJKqvTwrnNFZ4SAAAAAAAAAAAAAAAAAACAiccbAiZttPz0N/8AAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDropdown);
export default __webpack_public_path__ + "static/media/filterDropdown.e6a2103c9cca1e5eb9f1dd3d1e2365dd.svg";
export { ForwardRef as ReactComponent };